// 호스트 셸(상단바·사이드바) 번역 사전 — 모듈 화면의 문구는 각 모듈이 자기 사전으로 번역한다.
// 키를 추가할 때는 ko 에 먼저 넣는다(MessageKey 가 ko 의 키에서 나온다). ja/en 에 빠진 키는 ko 로 보인다.

const ko = {
  // 상단 탭 · 사이드바 메뉴
  'nav.home': '홈',
  'nav.mail': '메일',
  'nav.messenger': '메신저',
  'nav.board': '게시판',
  'nav.oneffice': 'ONEFFICE',
  'nav.videoconf': '화상회의',
  'nav.onechamber': 'ONECHAMBER',
  'nav.finance': '회계관리',
  'nav.basicinfo': '기초정보관리',
  'nav.pjt': '프로젝트관리',
  'nav.hr': '인사관리',
  'nav.tax': '세무신고',
  'nav.erpMain': '메인',
  'nav.aiUsage': 'AI 사용량',
  'nav.settings': '설정',
  'nav.help': '도움말',
  'nav.aiChatTab': 'AI 대화 #{num}',
  'nav.closeTab': '탭 닫기',

  // 사이드바
  'sidebar.newChat': '새 AI 대화',
  'sidebar.pin': '고정하기',
  'sidebar.pinTitle': '사이드바 고정',
  'sidebar.unpin': '사이드바 접기',

  // 상단바 우측
  'top.notifications': '알림',
  'top.portalDefault': '기본 포털',
  'top.portalZeirishi': '세리사무소 포털',
  'top.portalToggle': '{portal} — 눌러서 전환',
  'top.logout': '로그아웃',

  // 언어 변경 (KRDS Language switcher)
  'lang.button': '언어 변경',
  'lang.listLabel': '표시 언어 선택',
  'lang.name.ko': '한국어',
  'lang.name.ja': '일본어',
  'lang.name.en': '영어',
  'lang.changed': '표시 언어를 {name}(으)로 변경했습니다',
};

export type MessageKey = keyof typeof ko;

const ja: Partial<Record<MessageKey, string>> = {
  'nav.home': 'ホーム',
  'nav.mail': 'メール',
  'nav.messenger': 'メッセンジャー',
  'nav.board': '掲示板',
  'nav.videoconf': 'ビデオ会議',
  'nav.finance': '会計管理',
  'nav.basicinfo': '基礎情報管理',
  'nav.pjt': 'プロジェクト管理',
  'nav.hr': '人事管理',
  'nav.tax': '税務申告',
  'nav.erpMain': 'メイン',
  'nav.aiUsage': 'AI 使用量',
  'nav.settings': '設定',
  'nav.help': 'ヘルプ',
  'nav.aiChatTab': 'AI チャット #{num}',
  'nav.closeTab': 'タブを閉じる',

  'sidebar.newChat': '新しい AI チャット',
  'sidebar.pin': '固定する',
  'sidebar.pinTitle': 'サイドバーを固定',
  'sidebar.unpin': 'サイドバーを折りたたむ',

  'top.notifications': 'お知らせ',
  'top.portalDefault': '基本ポータル',
  'top.portalZeirishi': '税理士事務所ポータル',
  'top.portalToggle': '{portal} — クリックで切り替え',
  'top.logout': 'ログアウト',

  'lang.button': '言語切替',
  'lang.listLabel': '表示言語の選択',
  'lang.name.ko': '韓国語',
  'lang.name.ja': '日本語',
  'lang.name.en': '英語',
  'lang.changed': '表示言語を{name}に変更しました',
};

const en: Partial<Record<MessageKey, string>> = {
  'nav.home': 'Home',
  'nav.mail': 'Mail',
  'nav.messenger': 'Messenger',
  'nav.board': 'Board',
  'nav.videoconf': 'Video call',
  'nav.finance': 'Accounting',
  'nav.basicinfo': 'Master data',
  'nav.pjt': 'Projects',
  'nav.hr': 'HR',
  'nav.tax': 'Tax filing',
  'nav.erpMain': 'Main',
  'nav.aiUsage': 'AI usage',
  'nav.settings': 'Settings',
  'nav.help': 'Help',
  'nav.aiChatTab': 'AI chat #{num}',
  'nav.closeTab': 'Close tab',

  'sidebar.newChat': 'New AI chat',
  'sidebar.pin': 'Pin',
  'sidebar.pinTitle': 'Pin sidebar',
  'sidebar.unpin': 'Collapse sidebar',

  'top.notifications': 'Notifications',
  'top.portalDefault': 'Default portal',
  'top.portalZeirishi': 'Tax office portal',
  'top.portalToggle': '{portal} — click to switch',
  'top.logout': 'Log out',

  'lang.button': 'Language',
  'lang.listLabel': 'Choose display language',
  'lang.name.ko': 'Korean',
  'lang.name.ja': 'Japanese',
  'lang.name.en': 'English',
  'lang.changed': 'Display language changed to {name}',
};

export const MESSAGES: Record<'ko' | 'ja' | 'en', Partial<Record<MessageKey, string>>> = { ko, ja, en };
